const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

export const initializeGoogleAnalytics = () => {
  if (!GA_MEASUREMENT_ID) return
  if ('gtag' in window && typeof window.gtag === 'function') return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // biome-ignore lint/complexity/noArguments: gtag の標準的な初期化パターン
    window.dataLayer.push(arguments)
  }

  window.gtag('js', new Date())
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false, debug_mode: import.meta.env.DEV })
}
